import { ErrorDisplayType, useGlobalErrorStore } from 'scbk-services';
import { ErrorInfo } from '../stores/useGlobalErrorStore';

/**
 * 오류 직접 처리
 */
function useError() {
    const { setErrorInfo } = useGlobalErrorStore.getState();
    /**
     *
     * @param error 에러정보
     * @param callback 확인버튼 콜백 함수 정의
     * @returns
     */
    const showErrorMessage = async (error: ErrorInfo, callback?: () => void) => {
            useGlobalErrorStore.getState().setErrorInfo({
                ...error,
                displayType: ErrorDisplayType.MODAL,
                onConfirm: () => {
                    callback && callback?.();
                },
            });
    };

    /**
     *
     * @param error
     */
    const throwError = (error: ErrorInfo) => {
        setErrorInfo({ ...error });
    };

    return { throwError, showErrorMessage };
}

export { useError };
